import React, { useEffect, useState } from "react";
import { api } from "../api";
import { formatPrice } from "./HomePage";

export default function MockCheckoutPage({ token }) {
  const [session, setSession] = useState(null);
  const [error, setError] = useState("");
  const [notice, setNotice] = useState("");

  useEffect(() => {
    api
      .get(`/api/mock-checkout/${token}`)
      .then((d) => setSession(d.course))
      .catch((e) => setError(e.message));
  }, [token]);

  const confirm = (e) => {
    e.preventDefault();
    // Real card processing isn't wired up yet - clicking Pay doesn't charge
    // anything or enroll anyone. Point the visitor at support instead of
    // silently doing nothing (or faking a purchase).
    setNotice("Contact support for help");
  };

  return (
    <div className="page page-narrow">
      <div className="auth-card">
        <div className="test-mode-banner">WELCOME TO INSIDELMS</div>
        <h1>Checkout</h1>
        {error && <div className="alert alert-error">{error}</div>}
        {notice && <div className="alert alert-warning">{notice}</div>}
        {session && (
          <>
            <div className="checkout-summary">
              <span>{session.title}</span>
              <strong>{formatPrice(session.priceCents, session.currency, session.billingType)}</strong>
            </div>
            <form onSubmit={confirm}>
              <label>
                Card number
                <input disabled />
              </label>
              <div style={{ display: "flex", gap: 12 }}>
                <label style={{ flex: 1 }}>
                  Expiry
                  <input disabled />
                </label>
                <label style={{ flex: 1, minWidth: 0 }}>
                  CVC
                  <input disabled />
                </label>
              </div>
              <button className="btn btn-primary btn-block">
                Pay {formatPrice(session.priceCents, session.currency, session.billingType)}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
